// Utility functions for handling hash-based routing

/**
 * Parse URL parameters from hash-based routing
 * Handles URLs like: /#/search?category=electronics&page=2
 */
export const parseHashParams = () => {
  const hash = window.location.hash;

  // Remove the # and get the path and search params
  const hashContent = hash.substring(1); // Remove #

  // Split path and search params
  const [path, search] = hashContent.split('?');

  if (!search) {
    return { path, params: new URLSearchParams() };
  }

  return { path, params: new URLSearchParams(search) };
};

/**
 * Get a specific parameter from hash-based URL
 */
export const getHashParam = (paramName) => {
  const { params } = parseHashParams();
  return params.get(paramName);
};

/**
 * Get all parameters from hash-based URL
 */
export const getAllHashParams = () => {
  const { params } = parseHashParams();
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
};

/**
 * Update hash URL with new parameters
 */
export const updateHashUrl = (path, params = {}) => {
  const urlParams = new URLSearchParams();

  // Add new parameters
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      urlParams.set(key, value);
    }
  });

  // Build new hash URL
  const searchString = urlParams.toString();
  const newHash = searchString ? `#${path}?${searchString}` : `#${path}`;

  // Update URL without page reload
  window.history.replaceState({}, '', newHash);

  return newHash;
};

/**
 * Navigate to a new hash URL
 */
export const navigateToHash = (path, params = {}) => {
  const urlParams = new URLSearchParams();

  // Add new parameters
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      urlParams.set(key, value);
    }
  });

  // Build new hash URL
  const searchString = urlParams.toString();
  const newHash = searchString ? `#${path}?${searchString}` : `#${path}`;

  // Navigate to new URL
  window.location.hash = newHash;

  return newHash;
};
